module.exports = __webpack_public_path__ + "01edb027dd883ec7a59a0e801d870af5.png";